
import * as _ from 'underscore'

import { DataProvider } from "../helpers"

import { Enums } from "../models/common"
import { OpIssue, OpFile, OpIssueStatus } from "../models/core"
import { ColumnInfo, OpIssueStatusFlow } from "../models/custom"


export class DataProviderIssue {

    // Ctor

    constructor(private dataProvider: DataProvider) { }

    // Ctor End


    // Public Methods

    public deleteIssue = (opObj: OpIssue): JQueryPromise<OpIssue> => {
        opObj.opState = Enums.OpChangeState.Modified
        opObj.dataList.setValue(Enums.IssueStatus.CANCELLED, Enums.DataType.HELPER_ID_ISSUE_STATUS)

        return this.saveIssue(opObj)
    }

    public deleteIssueAttachment = (id: number, idFile: number[]): JQueryPromise<void> => {
        return this.dataProvider.sendRequestWithSession('OpxDeleteIssueAttachment', { idIssue: id, IdFile: idFile }, null)
    }

    public getIssue = (id: number): JQueryPromise<OpIssue> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetIssue', { IdIssue: id }, 'OpxGetIssueResult')
            .then((data: Object) => {
                const result: OpIssue = new OpIssue(data)

                OpIssue.loadNavigationProperties(this.dataProvider, [result])

                return result
            })
    }

    public getIssueAttachment = (id: number, idFile: number[] = null): JQueryPromise<OpFile[]> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetIssueAttachment', { idIssue: id, IdFile: idFile }, 'OpxGetIssueAttachmentResult')
            .then((response: any[]) => {
                return response.map(opObj => new OpFile(opObj))
            })
    }

    public getIssueAttachmentPacked = (id: number, filesId: number[]) => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetIssueAttachmentPacked', { idIssue: id, idFile: filesId }, 'OpxGetIssueAttachmentPackedResult')
            .then((response: any) => {
                return new OpFile(response)
            })
    }

    public getIssueFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
        return this.dataProvider.sendFilterRequestWithSession<OpIssue>(columns, pageNbr, pageSize, customWhereClause, Enums.ReferenceType.IdIssue, 'OpxIssueFilter', 'OpxIssueFilterResult')
    }

    public saveIssue = (opObj: OpIssue): JQueryPromise<OpIssue> => {
        return this.dataProvider
            .sendRequestWithSession('OpxSaveIssue', { ToBeSaved: opObj.toJSON() }, 'OpxSaveIssueResult')
            .then((data: Object) => {
                const result: OpIssue = new OpIssue(data)

                OpIssue.loadNavigationProperties(this.dataProvider, [result])
                return result
            })
    }

    public saveIssueAttachment = (id: number, file: OpFile): JQueryPromise<OpFile> => {
        return this.dataProvider
            .sendRequestWithSession('OpxSaveIssueAttachment', { IdIssue: id, file: file.toJSON() }, 'OpxSaveIssueAttachmentResult')
            .then((response: any[]) => {
                return new OpFile(response)
            })
    }

    public getIssueStatusFlow = (): JQueryPromise<OpIssueStatusFlow[]> => {
        return this.dataProvider.System.getFlow<OpIssueStatusFlow>(Enums.DataType.HELPER_ID_ISSUE_STATUS)
    }

    public getNextIssueStatuses = (issueStatus: Enums.IssueStatus): JQueryPromise<OpIssueStatus[]> => {
        return this.dataProvider.System.getFlowByStatus<OpIssueStatusFlow, OpIssueStatus>(Enums.DataType.HELPER_ID_ISSUE_STATUS, (status: OpIssueStatusFlow) => status.issueStatus.idIssueStatus === issueStatus)
    }

    public getIssuesByReferenceType = (referenceType: Enums.ReferenceType, idReferencetype: number) => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetIssuesByReferenceType', { referenceType: referenceType, idReferenceType: idReferencetype }, 'OpxGetIssuesByReferenceTypeResult')
            .then((data: any[]) => {
                if (_.size(data) > 0) {
                    const result: OpIssue[] = _.map(data, (d: any) => new OpIssue(d))

                    OpIssue.loadNavigationProperties(this.dataProvider, result)
                    return result
                }

                return []
            })
    }

    // Public Methods End
}